
import "./DBSCANIris.css";
import DBSCANIrisSmall from "./DBSCANIrisSmall"
import DBSCANIrisLarge from "./DBSCANIrisLarge"

function DBSCANIris() {

  return (
    <div>
      <DBSCANIrisSmall />
      <DBSCANIrisLarge />
    </div>
  );
}

export default DBSCANIris;
